import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Index from "./pages/Index";
import QrScanRedirect from "./pages/QrScanRedirect";
import AdminDashboard from "./pages/AdminDashboard";
import ProductDetail from "./pages/ProductDetail";
import StoreManagement from "./pages/StoreManagement";
import ProductManagement from "./pages/ProductManagement";
import AuthPage from "./pages/AuthPage";
import NotFound from "./pages/NotFound";
import AboutBazar from "./pages/AboutBazar";
import SellProductForm from "./features/sell/SellProductForm";
import SellRequestManagement from "./pages/SellRequestManagement";
import OrderManagement from "./pages/OrderManagement";
import ProtectedRoute from "./components/ProtectedRoute";
import { Analytics } from "@vercel/analytics/react";
import BuyProduct from "@/features/buy/BuyProduct";
import TrackingOrderPage from "./pages/TrackingOrderPage";
import { TokoPage } from "./pages/TokoPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/scan/redirect" element={<QrScanRedirect />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/stores" element={<StoreManagement />} />
              <Route path="/admin/products" element={<ProductManagement />} />
              <Route path="/admin/orders" element={<OrderManagement />} />
              <Route path="/admin/sell-requests" element={<SellRequestManagement />} />
              <Route path="/admin/product/:id" element={<ProductDetail />} />
            </Route>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/about" element={<AboutBazar />} />
            <Route path="/sell-product" element={<SellProductForm />} />
            <Route path="/buy/:id" element={<BuyProduct />} />
            <Route path="/tracking-order" element={<TrackingOrderPage />} />
            <Route path="/test-toko/:id" element={<TokoPage />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Analytics />
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
